export default {"src":"/_next/static/media/shield.bf3de651.svg","height":16,"width":14,"blurWidth":0,"blurHeight":0};